import { Pipe, PipeTransform } from '@angular/core';

// https://stackoverflow.com/questions/48217947/angular-5-convert-enum-int-to-string?noredirect=1&lq=1

@Pipe({ 
  name: 'enumString',
standalone:true,

})
export class EnumStringPipe implements PipeTransform {
  transform(value: any, enumType: any, inSentence: boolean = false): any {
    if (enumType && enumType.toString && enumType && typeof enumType.toString === 'function') {
      return enumType.toString(value, inSentence);
    } else {
      console.error('The Enum: ' + enumType + ' is missing a toString() method.');
      if (enumType) {
        return enumType[value]
          .split(/(?=[A-Z])/)
          .join()
          .replace(',', ' ');
      } else {
        return 'ERROR';
      }
    }
  }
}
